function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M161.263 37.2906C161.055 37.3538 160.832 37.2614 160.729 37.0698C160.3 36.3929 161.09 35.52 160.919 34.7368C160.782 34.1093 160.07 33.7368 159.924 33.1113C159.782 32.5034 160.218 31.8183 159.924 31.2683C159.693 30.8374 159.116 30.724 158.634 30.7995C158.151 30.875 157.693 31.0874 157.205 31.1171C156.556 31.1568 155.937 30.8705 155.301 30.7287C154.666 30.5868 153.891 30.6423 153.517 31.1758C153.038 31.8608 153.524 32.8145 153.357 33.6343C153.225 34.2852 152.68 34.8241 152.669 35.4884C152.664 35.7245 153.284 35.5343 153.251 35.7681C153.219 36.0019 153.512 35.796 153.277 35.7682C153.081 35.7201 152.938 35.5503 152.925 35.3485C152.897 35.1538 152.531 35.0889 152.536 34.8922C152.545 34.4313 151.713 34.742 151.576 34.3019C151.261 33.2758 151.325 32.1704 151.758 31.1882C151.981 30.787 152.159 30.3623 152.289 29.9219C152.411 29.3108 152.219 28.6547 152.421 28.065C152.693 27.2703 153.592 26.8652 154.427 26.7829C155.262 26.7006 156.111 26.8479 156.941 26.7266C157.685 26.6179 158.405 26.2952 159.155 26.342C160.055 26.3981 160.839 26.9787 161.463 27.6306C162.087 28.2826 162.616 29.0324 163.325 29.5909C163.542 29.7404 163.742 29.9129 163.922 30.1055C164.283 30.5458 164.319 31.1731 164.219 31.7338C164.118 32.2945 163.9 32.8293 163.808 33.3914C163.721 33.9196 163.748 34.4593 163.71 34.9933C163.702 35.5319 163.539 36.0567 163.241 36.5055C162.98 36.8597 162.571 37.0738 162.132 37.0856C161.981 37.0891 161.855 36.954 161.703 36.9892C161.514 37.0333 161.431 37.2134 161.263 37.2906Z",
  fill: "#2F2E41"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M167.688 76.0982L167.131 79.5223L166.018 78.0093L166.654 75.7002L167.688 76.0982Z",
  fill: "#A0616A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M166.972 50.22L167.849 52.5329C167.849 52.5329 168.722 64.3137 168.722 65.1896C168.722 66.0655 168.086 77.2926 167.847 77.7704C167.847 77.7704 166.813 76.2575 165.461 76.4964C164.109 76.7353 164.665 72.5151 164.665 72.5151L163.393 62.0842L163.631 56.8289L166.972 50.22Z",
  fill: "#CCD2E0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M161.563 37.48C161.563 37.48 158.939 44.1685 160.45 45.4425C161.961 46.7165 152.019 43.2926 152.019 43.2926L152.257 42.4168C152.257 42.4168 155.518 41.1427 153.928 37.48C152.337 33.8172 161.563 37.48 161.563 37.48Z",
  fill: "#A0616A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M161.563 37.48C161.563 37.48 158.939 44.1685 160.45 45.4425C161.961 46.7165 152.019 43.2926 152.019 43.2926L152.257 42.4168C152.257 42.4168 155.518 41.1427 153.928 37.48C152.337 33.8172 161.563 37.48 161.563 37.48Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M165.699 126.82C165.699 126.82 166.813 126.501 167.449 127.297C168.086 128.094 170.472 130.084 170.472 130.084C170.472 130.084 175.085 129.606 175.721 131.916C176.358 134.225 168.483 134.225 166.574 133.667C164.665 133.11 164.268 133.667 164.268 133.667C164.268 133.667 158.382 134.145 158.382 133.19C158.382 132.234 158.939 128.969 158.939 128.969L165.699 126.82Z",
  fill: "#575A89"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M147.008 132.154L148.042 135.34C148.042 135.34 151.144 139.639 149.394 140.515C147.644 141.391 141.44 142.267 141.44 139.958V135.578C141.44 135.578 142.076 132.473 142.713 132.154C143.349 131.836 147.008 132.154 147.008 132.154Z",
  fill: "#575A89"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M164.573 74.9332C164.573 74.9332 167.926 77.85 167.847 78.2481C167.767 78.6463 166.177 104.206 166.177 104.206L165.302 120.768C165.302 120.768 166.415 124.67 165.858 125.546C165.302 126.421 166.654 126.66 166.654 126.66C166.654 126.66 160.927 131.836 158.541 129.606L156.314 100.702L150.189 121.724C150.189 121.724 149.155 132.871 147.962 132.871C146.769 132.871 141.917 133.11 141.997 132.473C142.076 131.836 141.758 126.979 142.315 124.112C142.872 121.246 146.61 98.5526 146.61 98.5526C146.61 98.5526 146.931 79.0981 146.095 77.2797C145.258 75.4613 146.53 73.5503 146.53 73.5503L152.098 71.4004L158.779 72.1966L164.573 74.9332Z",
  fill: "#7D86A1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M158.124 40.9066C161.034 40.9066 163.393 37.7398 163.393 33.8335C163.393 29.9271 161.034 26.7604 158.124 26.7604C155.214 26.7604 152.854 29.9271 152.854 33.8335C152.854 37.7398 155.214 40.9066 158.124 40.9066Z",
  fill: "#A0616A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M144.303 46.6369C144.862 45.0545 146.176 43.8582 147.803 43.4519C149.407 43.0479 150.977 42.5153 152.496 41.8594C152.496 41.8594 158.143 44.5666 159.257 44.5666C160.37 44.5666 160.37 43.85 160.37 43.85C160.37 43.85 163.234 46.8758 164.745 47.1943C166.256 47.5128 168.483 51.2552 167.688 53.3254C167.148 54.6527 166.365 55.8677 165.381 56.9086C165.381 56.9086 165.699 68.0561 164.665 70.1264C164.665 70.1264 167.211 74.9835 164.824 75.302C162.438 75.6205 153.291 74.5058 151.7 75.6205C150.11 76.7353 147.167 75.3816 146.769 76.8945C146.371 78.4074 145.496 78.7259 145.496 78.7259C145.496 78.7259 144.144 76.576 144.94 75.302C145.735 74.028 144.303 46.6369 144.303 46.6369Z",
  fill: "#CCD2E0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M150.189 76.576L151.462 77.3723C151.462 77.3723 150.11 82.0702 149.553 82.2294C148.996 82.3887 147.686 78.2124 147.686 78.2124L150.189 76.576Z",
  fill: "#A0616A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M162.217 36.7332C162.01 36.7965 161.786 36.704 161.684 36.5124C161.254 35.8355 162.045 34.9626 161.873 34.1794C161.736 33.5519 161.024 33.1795 160.878 32.5539C160.737 31.9461 161.173 31.2609 160.878 30.7109C160.647 30.2801 160.071 30.1667 159.588 30.2421C159.105 30.3176 158.647 30.53 158.16 30.5598C157.51 30.5994 156.891 30.3131 156.256 30.1713C155.62 30.0294 154.846 30.085 154.472 30.6184C153.992 31.3034 154.479 32.2572 154.312 33.0769C154.179 33.7278 152.668 34.1847 152.53 33.7445C152.215 32.7185 152.28 31.613 152.713 30.6308C152.936 30.2296 153.114 29.8049 153.244 29.3646C153.366 28.7534 153.174 28.0973 153.375 27.5076C153.647 26.7129 154.546 26.3078 155.382 26.2255C156.217 26.1433 157.065 26.2905 157.895 26.1692C158.639 26.0605 159.359 25.7378 160.109 25.7846C161.01 25.8407 161.793 26.4213 162.417 27.0733C163.041 27.7252 163.57 28.475 164.279 29.0335C164.496 29.183 164.696 29.3555 164.876 29.5481C165.237 29.9884 165.274 30.6157 165.173 31.1764C165.073 31.7371 164.854 32.2719 164.762 32.834C164.675 33.3623 164.702 33.9019 164.665 34.4359C164.656 34.9746 164.493 35.4994 164.195 35.9481C163.935 36.3023 163.525 36.5164 163.086 36.5282C162.936 36.5317 162.809 36.3966 162.657 36.4318C162.468 36.4759 162.386 36.656 162.217 36.7332Z",
  fill: "#2F2E41"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M147.445 48.0303L144.86 46.6369C144.86 46.6369 138.577 61.6065 140.088 65.747C141.599 69.8875 147.405 78.4074 147.405 78.4074C147.405 78.4074 152.019 77.4519 151.541 76.4964C151.064 75.5409 147.962 69.4097 147.724 68.6135C147.485 67.8172 145.894 62.6416 146.61 62.0842C147.326 61.5268 148.718 48.5877 148.718 48.5877L147.445 48.0303Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M147.485 45.761L144.303 46.6369C144.303 46.6369 138.02 61.6064 139.531 65.747C141.042 69.8875 146.849 78.4074 146.849 78.4074C146.849 78.4074 151.462 77.4519 150.985 76.4964C150.507 75.5409 147.405 69.4097 147.167 68.6135C146.928 67.8172 145.337 62.6416 146.053 62.0842C146.769 61.5268 150.189 47.7516 150.189 47.7516L147.485 45.761Z",
  fill: "#CCD2E0"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 117.621,
  y: 34.523,
  width: 2.04087,
  height: 16.8451,
  rx: 0.549998,
  fill: "#7D86A1"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 49.772,
  y: 21.3263,
  width: 1.14539,
  height: 5.54552,
  rx: 0.360785,
  fill: "#7D86A1"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 49.7302,
  y: 31.4792,
  width: 1.29117,
  height: 9.65255,
  rx: 0.406704,
  fill: "#7D86A1"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 49.751,
  y: 44.5091,
  width: 1.22869,
  height: 9.73594,
  rx: 0.387024,
  fill: "#7D86A1"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 50.4207,
  y: 2.99997,
  width: 68.3014,
  height: 138.963,
  rx: 8.56655,
  fill: "#7D86A1"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 77.9827,
  y: 7.1498,
  width: 9.53796,
  height: 1.93885,
  rx: 0.610054,
  fill: "#E6E8EC"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M90.0614 9.21895C90.6681 9.21895 91.16 8.72658 91.16 8.11922C91.16 7.51186 90.6681 7.0195 90.0614 7.0195C89.4547 7.0195 88.9629 7.51186 88.9629 8.11922C88.9629 8.72658 89.4547 9.21895 90.0614 9.21895Z",
  fill: "#E6E8EC"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M114.504 12.0505V132.914C114.503 135.913 112.075 138.343 109.079 138.343H60.0635C57.068 138.343 54.6393 135.913 54.6387 132.914V12.0505C54.6385 10.6102 55.2101 9.22877 56.2274 8.21028C57.2448 7.19179 58.6247 6.61966 60.0635 6.61979H67.3983V7.56289C67.399 10.0323 69.3985 12.034 71.8652 12.0347H96.7927C99.2597 12.0347 101.26 10.0326 101.26 7.56289V6.61979H109.079C110.518 6.61966 111.898 7.19179 112.915 8.21028C113.933 9.22877 114.504 10.6102 114.504 12.0505Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M69.6638 57.7534L93.6638 74.2466",
  stroke: "#B3247C",
  strokeWidth: 0.200106
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M93.6638 57.7534L69.6638 74.2466",
  stroke: "#B3247C",
  strokeWidth: 0.200106
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.7753 79.9204L89.973 79.3643L89.5243 78.5512C92.5626 76.6404 94.9505 73.6794 96.0839 70.0065C98.6113 61.8165 94.0212 53.1293 85.8313 50.6019C77.6413 48.0746 68.9541 52.6646 66.4267 60.8545C63.8994 69.0445 68.4894 77.7318 76.6794 80.2591C80.3523 81.3925 84.144 81.0885 87.4346 79.6553L87.8535 80.4842L87.2973 82.2864L95.191 97.1902L99.6391 94.84L91.7753 79.9204ZM77.7162 77.1681C71.0733 75.1182 67.3413 68.1798 69.3611 61.6345C71.3809 55.0892 78.3738 51.4605 85.0168 53.5104C91.6598 55.5604 95.3917 62.4987 93.3719 69.044C91.3521 75.5893 84.3592 79.2181 77.7162 77.1681Z",
  fill: "#7D86A1"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M197.018 75.7177C199.423 75.7177 201.372 73.7662 201.372 71.3588C201.372 68.9515 199.423 67 197.018 67C194.613 67 192.664 68.9515 192.664 71.3588C192.664 73.7662 194.613 75.7177 197.018 75.7177Z",
  fill: "#2F313D"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M134.869 23.0073C125.472 30.9751 113.284 30.4596 102.603 26.3133C91.9225 22.1671 82.1112 14.7879 71.7047 9.54167C62.9805 5.14377 53.8255 2.25581 44.5588 0.971149C31.2956 -0.867566 16.4843 1.37705 7.24401 14.2521C-3.0467 28.5965 -2.25636 54.4684 8.8694 67.6276C14.5318 74.3249 21.9456 77.6127 28.4106 82.8487C34.8755 88.0848 40.863 96.7629 40.3125 106.858C39.8025 116.193 33.8759 123.371 27.7421 127.871C23.0021 131.347 17.165 135.145 16.594 142.347C16.0414 149.314 20.9501 154.776 25.6373 157.881C40.9281 168.01 59.7703 167.913 75.0083 157.625C80.4412 153.954 85.4311 149.071 91.1301 146.213C106.094 138.704 122.583 146.262 138.429 149.028C151.838 151.368 165.591 150.155 178.657 145.481C186.504 142.674 194.381 138.378 199.893 130.389C203.869 124.626 220.452 101.042 218.897 72.4679C218.404 63.3949 216.833 54.4359 213.148 46.7848C204.397 28.6148 190.673 17.4156 173.698 12.594C156.722 7.77243 134.869 23.0073 134.869 23.0073Z",
  fill: "#7D86A1"
});

var SvgHasNoResults = function SvgHasNoResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 166,
    viewBox: "0 0 219 166",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHasNoResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hasNoResults.cb04a29d.svg";
export { ForwardRef as ReactComponent };